var exports = {
  "y": "xa15a2ab7--2d5a9a--popup-link",
};

module.exports = exports;
